import { useEffect, useState, useRef, useContext } from "react";
import { useForm } from "react-hook-form";
import NavBar from "../layout/NavBar";
import { toast } from "react-toastify";
import { http } from "../auth";

/*-----Iconos-----*/
import { MdArrowForwardIos, MdOutlineKeyboardArrowLeft } from "react-icons/md";
import "../styles/pagar.css";
import { Row, Col, Modal } from "react-bootstrap";
import { TbPigMoney } from "react-icons/tb";
import { Link, useLocation } from "react-router-dom";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import Billimg from "../components/Billimg";
import { useThemeManager } from "../Hooks/ThemeManager";

const Pagar = () => {
  const { themeColors } = useThemeManager();
  const [data, setData] = useState([]);
  const [numero, setNumero] = useState(2);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const location = useLocation();

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      // PRIMERO: Intentar usar datos del state (de la navegación)
      if (location.state?.paymentData) {
        setData(location.state.paymentData);
        setLoading(false);
        return;
      }
      // SEGUNDO: Hacer la llamada a la API solo si es necesario
      try {
        const response = await http.get(`/intranet-j/metodos-pago`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(response.data);
        setLoading(false);

        const numeroDeFacturas = response.data?.facturas?.length;
        const idsFacturas = response.data?.facturas?.map((factura) => factura.id) || [];
        localStorage.setItem("numeroDeFacturas", numeroDeFacturas);
        localStorage.setItem("idsFacturas", JSON.stringify(idsFacturas));

      } catch (error) {
        if (error?.response?.status === 403) {
          setError(error?.response?.data?.detail || "Error al cargar datos");
          setLoading(false);
          return;
        }
        console.error("Error:", error);
        setError(error?.response?.data?.detail || "Error al cargar datos");
        toast.error("Error al cargar los datos");
        setLoading(false);
      }
    };

    loadData();
  }, [location.state]);

  const factura = true;
  const abonar = true;

  return (
    <div>
      <div className="header-pago">
        <Link to="/pago" className="back">
          <div className="color-primary">
            <MdOutlineKeyboardArrowLeft className="btn-back" />
          </div>
          <div>
            <span>Volver</span>
          </div>
        </Link>
      </div>
      <div className="containerPagos color-secondary">
        {(loading || data?.config?.allow_advance_payment?.enabled || data?.facturas?.length > 0 || data?.online?.length > 0) ? (
          <div className="pagosContainer">
            <span className="tituloRealizar">Realizar pagos online</span>
            <span className="mb-4">Seleccione el destino del pago</span>
            {loading ? (
              <div className="contenSpinner">
                <div className="spinner blue"></div>
              </div>
            ) : (
            <>
            {data?.online?.length > 0 && (
              <Link
                to={{
                  pathname: "/metodos",
                }}
                state={{ abonar }}
                className="no-line"
              >
                <div className={`${data?.facturas?.length > 0 ? "formasBorder top" : "formasBorder all-border"}`}>
                  <Row className="formasPago">
                    <Col xs={10} sm={9} xl={10} className="col-metodo-2">
                      <div className="p-2">
                        <TbPigMoney className="iconDetails me-3" />
                      </div>
                      <div className="col-metodo color-secondary">
                        <span className="titulo-pago">Abonar a servicios</span>
                        <span>Adelanta pagos y evita la suspensión</span>
                      </div>
                    </Col>
                    <Col xs={2} sm={3} xl={2} className="iconPago color-secondary">
                      <MdArrowForwardIos size={25} className="iconPago-size" />
                    </Col>
                  </Row>
                </div>
              </Link>
            )}
            {data?.facturas?.length > 0 && (
              <Link
                to={{
                  pathname: "/metodos",
                }}
                state={{ factura }}
                className="no-line"
              >
                <div className={`${data?.online?.length > 0 ? "formasBorder bottom" : "formasBorder all-border"}`}>
                  <Row className="formasPago">
                    <Col xs={10} sm={9} xl={10} className="col-metodo-2">
                      <div className="p-2">
                        <LiaFileInvoiceDollarSolid className="iconDetails me-3" />
                      </div>
                      <div className="col-metodo color-secondary">
                        <span className="titulo-pago">Pagar deuda</span>
                        Existe {data?.facturas?.length || 0}{" "}
                        {(data?.facturas?.length || 0) === 1 ? "documento" : "documentos"} pendiente
                        {(data?.facturas?.length || 0) === 1 ? "" : "s"} por pagar
                      </div>
                    </Col>
                    <Col xs={2} sm={3} xl={2} className="iconPago color-secondary">
                      <MdArrowForwardIos size={25} className="iconPago-size" />
                    </Col>
                  </Row>
                </div>
              </Link>
            )}
            </>
            )}
          </div>
        ) : (
          <div className="pagosContainer">
            <span className="tituloRealizar">Realizar pagos online</span>
            <span className="mb-4">
              {data?.config?.allow_advance_payment?.msg}
              {error}
            </span>
          </div>
        )}

        <div className="side-image mt-lg-5 mt-xl-0">
          <Billimg themeColors={themeColors} />
        </div>
      </div>
    </div>
  );
};

export default Pagar;
